<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="row mt-4">
			<label class="title_label"
				for="inputGroupSelect01">{{ $t("Music.select") }}</label>
		</div>
		<div class="row">
			<div class="col-8 col-lg-4">
				<form>
					<div class="form-group">
						<div class="input-group mb-3">
							<select class="custom-select"
								id="inputGroupSelect01"
								v-model="musicSelected"
								@change="setMusicPlayer">
								<option
									v-for="(element, index) in this.musics"
									:key="index"
									:value="element.id"
								>{{ element.name }}
									<!--									:selected="(musicSelected === element.id)"-->
								</option>
							</select>
						</div>
						<audio controls
							:src="audio"
							ref="audioPlayer"></audio>
					</div>
				</form>
			</div>
			<div class="col-6 col-lg-3" v-if="true">
				<div class="input-group mb-3">
					<input id="input_newfile" name="new_audio" type="file" accept="audio/mp3" @change="upload_file" />
					<label class="upload_label"
						for="input_newfile">{{ $t("Music.import") }}</label>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<ValidStep :musicId="musicSelected"
					:modal="$refs.loaderModal"
					:id="id" />
			</div>
		</div>
	</div>
</template>

<script>
import ValidStep from "../ui/buttons/ValidStepMusic";
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import Throbber from "../ui/throbber.vue";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Music",
	components: {
		Throbber,
		lottie_error,
		ValidStep,
	},
	props: {
		id: Number,
		stepName: String,
		isVisible: Boolean,
		isCompleted: Boolean,
		musicId: Number,
		projectId: Number,
		stepIndex: Number,
		groupId: String,
		created_at: String,
		updated_at: String,
	},
	data() {
		return {
			musics: [],
			audio: "",
			text_error: "",
			musicSelected: this.musicId,
		};
	},
	activated() {
		this.load_music();
	},
	deactivated() {
		this.musics = [];
	},
	methods: {
		load_music(last = false) {
			let $this = this;
			axios
			.get(BASE_URL + "/public/api/musics", {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let data = response.data.data;

				$this.musics = data.musics;

				if (last) {
					let item = $this.musics[$this.musics.length - 1];
					$this.audio = item.url;
					$this.musicSelected = item.id;
				}
				else {
					$this.audio = data.musics[0].url;
					if ($this.musicSelected === null) {
						$this.musicSelected = data.musics[0].id;
						$this.audio = data.musics[0].url;
					}
					else {
						$this.musics.forEach(function (item) {
							if (item.id === $this.musicSelected) {
								$this.audio = item.url;
								$this.musicSelected = item.id;
							}
						});
					}
				}
			}).catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		setMusicPlayer() {
			let $this = this;
			this.musics.forEach(function (item) {
				if (item.id === $this.musicSelected) {
					$this.audio = item.url;
				}
			});
		},
		upload_file() {
			let files = document.getElementById("input_newfile").files;
			let path = document.getElementById("input_newfile").value;
			if (!files.length) {
				return 0;
			}

			let name = path.split(/(\\|\/)/g).pop();
			let bodyFormData = new FormData();
			bodyFormData.append("music", files[0]);
			bodyFormData.append("name", name);

			let $this = this;
			axios.post(BASE_URL + "/public/api/addmusic",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.load_music(true);
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				console.log(e);
				$this.$refs.modalError.show();
			});
		},
	},
};
</script>

<style>

.btn {
	border-radius: var(--small-border-radius);
}

.title_label {
	font-size: 14px;
	color: #224B93;
}

#input_newfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.upload_label {
	font-weight: 400;
	color: var(--text-secondary-action);
	background-color: var(--color-secondary-action);
	display: inline-block;
	cursor: pointer;
	padding: 6px 12px;
	font-size: 16px;
	border-radius: var(--small-border-radius);
}

#input_newfile:focus + .upload_label,
#input_newfile + .upload_label:hover {
	background-color: var(--color-secondary-action);
}

</style>
